import { render, staticRenderFns } from "./profil-details.vue?vue&type=template&id=85c9953e&scoped=true"
import script from "./profil-details.vue?vue&type=script&lang=js"
export * from "./profil-details.vue?vue&type=script&lang=js"
import style0 from "./profil-details.vue?vue&type=style&index=0&id=85c9953e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c9953e",
  null
  
)

export default component.exports